import React from "react";

import { MatchesPanel } from "../matches_v2/parts/matches_panel";
import { SidePanel } from "../matches_v2/parts/side_panel";
import css from "./activity_matches.module.scss";

export const ActivityMatches = () => (
  <div className={css.container}>
    <SidePanel />
    <MatchesPanel />
  </div>
);
